import {createFileRoute} from '@tanstack/react-router';
import {ForbiddenErrorScreen} from 'shared';

import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/forbidden')({
  component: ForbiddenErrorScreen,
  beforeLoad: () => makeDocumentTitle('Forbidden'),
});
